import React from 'react';
import { Row, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { euroFormatter } from 'Reports/utils';
import {
  EmployeeReportItem,
  UserTransactionsResult,
} from 'utils/apiClient/services/reports/types';
import { extractCursorFromURL } from 'ShorePay/utils';
import CursorPagination from 'ShorePay/components/CursorPagination';

const columns: ColumnsType<EmployeeReportItem> = [
  {
    title: <FormattedMessage defaultMessage="Item Name" />,
    dataIndex: 'product_name',
    key: 'product_name',
  },
  {
    title: <FormattedMessage defaultMessage="Type" />,
    dataIndex: 'product_type',
    key: 'product_type',
    render: (value: string) =>
      value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '',
  },
  {
    title: <FormattedMessage defaultMessage="Items Sold" />,
    dataIndex: 'quantity',
    key: 'quantity',
    render: (value: EmployeeReportItem['quantity']) => (
      <FormattedNumber
        value={Number(value)}
        minimumFractionDigits={0}
        maximumFractionDigits={0}
      />
    ),
  },
  {
    title: <FormattedMessage defaultMessage="Discounts Given" />,
    dataIndex: 'discounts_applied',
    key: 'discounts_applied',
    render: (value: EmployeeReportItem['discounts_applied']) =>
      value ? euroFormatter(value) : '-',
  },
  {
    title: <FormattedMessage defaultMessage="Revenue" />,
    dataIndex: 'revenue',
    key: 'revenue',
    render: (value: EmployeeReportItem['revenue']) => euroFormatter(value),
  },
];

type EmployeeTransactionProps = {
  data: UserTransactionsResult;
  isLoading: boolean;
  onCursorChange?: (input: string, limit?: number) => void;
  limit?: number;
};

const EmployeeTransactionTable = ({
  data,
  isLoading,
  onCursorChange,
  limit = 10,
}: EmployeeTransactionProps) => (
  <>
    <Table
      columns={columns}
      dataSource={data?.results || []}
      loading={isLoading}
      pagination={false}
      rowKey={(record, idx) =>
        `${record.product_name}-${record.product_type}-${idx}`
      }
    />
    <Row justify="end" css={{ marginTop: '5px' }}>
      <CursorPagination
        previous={extractCursorFromURL(data?.previous ?? '')}
        next={extractCursorFromURL(data?.next ?? '')}
        onChange={(url: string) => {
          if (onCursorChange) {
            onCursorChange(url, limit);
          }
        }}
      />
    </Row>
  </>
);

export default EmployeeTransactionTable;
